import React from 'react';
import NavItem from './NavItem';

const Sidebar = ({ isOpen, onClose, activeSection, onSelect, onUserClick }) => {
  const handleSelect = (id) => {
    onSelect(id);
    onClose();
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`} id="sidebar" data-testid="sidebar">
      <div className="sidebar-logo">
        <div>
          <div className="logo-mark">RenX</div>
          <div className="logo-sub">CRM Platform</div>
        </div>
        <button className="close-sidebar-btn" onClick={onClose} data-testid="close-sidebar-btn">✕</button>
      </div>
      <nav className="sidebar-nav">
        <div className="nav-label">Core</div>
        <NavItem id="dashboard" icon="◈" label="Dashboard" active={activeSection} onClick={handleSelect} />
        <NavItem id="pipeline" icon="⬡" label="Lead Pipeline" active={activeSection} onClick={handleSelect} />
        <NavItem id="tasks" icon="☑" label="Tasks & Activities" active={activeSection} onClick={handleSelect} />
        <div className="nav-label">Management</div>
        <NavItem id="contacts" icon="◎" label="Contacts" active={activeSection} onClick={handleSelect} />
        <NavItem id="billing" icon="◇" label="Sales & Finance" active={activeSection} onClick={handleSelect} />
        <div className="nav-label">Settings</div>
        <NavItem id="preferences" icon="⊙" label="Preferences" active={activeSection} onClick={handleSelect} />
      </nav>
      <div className="sidebar-footer">
        <div className="user-card" onClick={onUserClick} data-testid="user-card">
          <div className="user-avatar">NE</div>
          <div>
            <div className="user-name">Narendra Eka</div>
            <div className="user-role">Account Executive</div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
